import React, { Component } from 'react'

import './style.css';

export class Statistic extends Component {
   render() {
      return (
         <div className='statistic_component' id='statistik'>
            <div className="statistic--block _container">
               <div className="stat--item">
                  <span className='stat_nummber'>12</span>
                  <span className='stat_about'>Years Of Experiance</span>
               </div>
               <div className="stat--item">
                  <span className='stat_nummber'>5K</span>
                  <span className='stat_about'>Success Project</span>
               </div>
               <div className="stat--item">
                  <span className='stat_nummber'>1K</span>
                  <span className='stat_about'>Active Project</span>
               </div>
               <div className="stat--item">
                  <span className='stat_nummber'>4K</span>
                  <span className='stat_about'>Happy Customers</span>
               </div>

            </div>

         </div>
      )
   }
}

export default Statistic
